import { PotentialClient } from '../types/client';

export const mockPotentialClients: PotentialClient[] = [
  {
    id: '1',
    civility: 'M.',
    firstName: 'Karim',
    lastName: 'Benhamadi',
    phone: '+213 555 234 567',
    email: 'k.benhamadi@email.com',
    address: 'Rue Didouche Mourad',
    wilaya: 'Alger',
    city: 'Alger Centre',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 20000000,
      maxBudget: 28000000,
      minArea: 85,
      minRooms: 3,
      bedroomCount: 2,
      hasParking: true,
      hasElevator: true,
    },
    interestLevel: 'very-interested',
    lastContact: new Date('2024-03-08'),
    notes: 'Recherche activement, disponible pour une visite rapidement. Préfère les étages élevés avec vue dégagée.',
    agent: 'Sarah Benali',
  },
  {
    id: '2',
    civility: 'Mme',
    firstName: 'Amina',
    lastName: 'Khelifi',
    phone: '+213 555 345 678',
    email: 'amina.k@email.com',
    address: 'Boulevard Mohamed V',
    wilaya: 'Alger',
    city: 'Hydra',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 22000000,
      maxBudget: 30000000,
      minArea: 90,
      minRooms: 4,
      bedroomCount: 3,
      hasParking: true,
      hasElevator: true,
      hasBalcony: true,
    },
    interestLevel: 'interested',
    lastContact: new Date('2024-03-05'),
    notes: 'Cherche un bien familial, cuisine séparée indispensable. Intéressée par le quartier.',
    agent: 'Karim Hadj',
  },
  {
    id: '3',
    civility: 'M.',
    firstName: 'Sofiane',
    lastName: 'Mesbah',
    phone: '+213 555 456 789',
    email: 'sofiane.mesbah@email.com',
    address: 'Rue des Frères Bouadou',
    wilaya: 'Alger',
    city: 'Bir Mourad Raïs',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 18000000,
      maxBudget: 25000000,
      minArea: 80,
      minRooms: 3,
      bedroomCount: 2,
      hasParking: false,
      hasElevator: true,
    },
    interestLevel: 'to-contact',
    lastContact: new Date('2024-02-28'),
    notes: 'Investisseur, ouvert aux propositions nécessitant des travaux. À recontacter en priorité.',
    agent: 'Mohamed Kadi',
  },
  {
    id: '4',
    civility: 'M.',
    firstName: 'Yacine',
    lastName: 'Bouaziz',
    phone: '+213 555 789 123',
    email: 'yacine.bouaziz@email.com',
    address: 'Rue Ahmed Ouaked',
    wilaya: 'Alger',
    city: 'Dely Ibrahim',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 24000000,
      maxBudget: 32000000,
      minArea: 95,
      minRooms: 4,
      bedroomCount: 3,
      hasParking: true,
      hasElevator: true,
      hasBalcony: true,
    },
    interestLevel: 'very-interested',
    lastContact: new Date('2024-03-10'),
    notes: 'Recherche un grand appartement pour sa famille, budget flexible pour le bon bien.',
    agent: 'Sarah Benali',
  },
  {
    id: '5',
    civility: 'Mme',
    firstName: 'Leila',
    lastName: 'Mansouri',
    phone: '+213 555 234 890',
    email: 'leila.mansouri@email.com',
    address: 'Boulevard Krim Belkacem',
    wilaya: 'Alger',
    city: 'Telemly',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 20000000,
      maxBudget: 26000000,
      minArea: 75,
      minRooms: 3,
      bedroomCount: 2,
      hasParking: true,
      hasElevator: false,
    },
    interestLevel: 'interested',
    lastContact: new Date('2024-03-09'),
    notes: 'Cherche un appartement lumineux, préfère les étages bas.',
    agent: 'Karim Hadj',
  },
  {
    id: '6',
    civility: 'M.',
    firstName: 'Redhouane',
    lastName: 'KABACHE',
    phone: '+213 555 234 890',
    email: 'leila.mansouri@email.com',
    address: 'Boulevard Krim Belkacem',
    wilaya: 'Alger',
    city: 'Telemly',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 20000000,
      maxBudget: 26000000,
      minArea: 75,
      minRooms: 3,
      bedroomCount: 2,
      hasParking: true,
      hasElevator: false,
    },
    interestLevel: 'interested',
    lastContact: new Date('2024-03-09'),
    notes: 'Cherche un appartement lumineux, préfère les étages bas.',
    agent: 'Karim Hadj',
  },
  {
    id: '7',
    civility: 'M.',
    firstName: 'Nadir',
    lastName: 'Boumediene',
    phone: '+213 555 987 654',
    email: 'nadir.boumediene@email.com',
    address: 'Rue Hassiba Ben Bouali',
    wilaya: 'Alger',
    city: 'Bab Ezzouar',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Villa',
      minBudget: 40000000,
      maxBudget: 50000000,
      minArea: 150,
      minRooms: 5,
      bedroomCount: 4,
      hasParking: true,
      hasGarden: true,
    },
    interestLevel: 'very-interested',
    lastContact: new Date('2024-03-12'),
    notes: 'Recherche une villa avec jardin pour sa famille.',
    agent: 'Sarah Benali',
  },
  {
    id: '8',
    civility: 'Mme',
    firstName: 'Djamila',
    lastName: 'Ait Ahmed',
    phone: '+213 555 654 321',
    email: 'djamila.aitahmed@email.com',
    address: 'Rue Larbi Ben Mhidi',
    wilaya: 'Alger',
    city: 'El Biar',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 25000000,
      maxBudget: 35000000,
      minArea: 100,
      minRooms: 4,
      bedroomCount: 3,
      hasParking: true,
      hasElevator: true,
    },
    interestLevel: 'interested',
    lastContact: new Date('2024-03-11'),
    notes: 'Cherche un appartement moderne avec une grande terrasse.',
    agent: 'Karim Hadj',
  },
  {
    id: '9',
    civility: 'M.',
    firstName: 'Mehdi',
    lastName: 'Bouziane',
    phone: '+213 555 321 654',
    email: 'mehdi.bouziane@email.com',
    address: 'Avenue Pasteur',
    wilaya: 'Alger',
    city: 'Hussein Dey',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 28000000,
      maxBudget: 38000000,
      minArea: 110,
      minRooms: 4,
      bedroomCount: 3,
      hasParking: true,
      hasElevator: true,
    },
    interestLevel: 'to-contact',
    lastContact: new Date('2024-03-07'),
    notes: 'Intéressé par un appartement avec vue sur mer.',
    agent: 'Mohamed Kadi',
  },
  {
    id: '10',
    civility: 'Mme',
    firstName: 'Sarah',
    lastName: 'Benyahia',
    phone: '+213 555 654 987',
    email: 'sarah.benyahia@email.com',
    address: 'Rue Didouche Mourad',
    wilaya: 'Alger',
    city: 'Alger Centre',
    criteria: {
      transactionType: 'sale',
      propertyType: 'Appartement',
      minBudget: 30000000,
      maxBudget: 40000000,
      minArea: 120,
      minRooms: 5,
      bedroomCount: 4,
      hasParking: true,
      hasElevator: true,
    },
    interestLevel: 'very-interested',
    lastContact: new Date('2024-03-06'),
    notes: 'Recherche un appartement spacieux avec un grand salon.',
    agent: 'Sarah Benali',
  }
];
